module.exports = __webpack_public_path__ + "static/img/main.7576b50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/km/main.jpg
// module id = HyHU
// module chunks = 2